import { makeStyles } from '@material-ui/core/styles'
import style from './style'

const useStyles = makeStyles(style)

export default useStyles
